import AuthService from "../shared/auth/auth.service.js";
import SettingsService from '../shared/settings/settings.service.js';

export default {
    downloadFile: (rok, miesiac) => {

        let anchor = document.createElement("a");
        document.body.appendChild(anchor);
        let file = `${SettingsService.apiUrl}/premie-miesieczne-api/policz-dla-sprzedawcy/${rok}/${miesiac}/log`;

        let headers = new Headers();

        AuthService.getAcessToken().then(accessToken => {
            headers.append('Authorization', `Bearer ${accessToken}`);
            fetch(file, { headers })
                .then(response => response.blob())
                .then(blobby => {
                    let objectUrl = window.URL.createObjectURL(blobby);

                    anchor.href = objectUrl;
                    anchor.download = `logiPremi-${rok}-${miesiac}.xlsx`;
                    anchor.click();

                    window.URL.revokeObjectURL(objectUrl);
                });
        });

    },
    loadHeader: () => {
        let webComponents = document.createElement("script");
        webComponents.setAttribute(
            "src",
            "https://cdnjs.cloudflare.com/ajax/libs/webcomponentsjs/1.2.0/webcomponents-loader.js"
        );
        document.head.appendChild(webComponents);
        let rainbowHeader = document.createElement("script");
        rainbowHeader.setAttribute(
            "src",
            SettingsService.travellaMenuScriptUrl
        );
        document.head.appendChild(rainbowHeader);

        AuthService.getAcessToken().then(accessToken => {
            if (accessToken) {
                const headerElement = document.querySelector("rainbow-header");
                headerElement.setAttribute("token", accessToken);
            }
        });

        AuthService.addAccessTokenChangeHandler((accessToken) => {
            const headerElement = document.querySelector("rainbow-header");
            headerElement.setAttribute("token", accessToken);
        });
    }
}